import { enums } from "@shared/constants";
import { PublicInternalAnalyticsTrackingSerializerWithLabelString } from "@shared/modules/analytics/types";
import { IInteractionDataBuilder } from "./IInteractionDataBuilder";
import { type RoktAnalyticsData } from "./RoktExposureDataBuilder";

export class RoktEngagementDataBuilder implements IInteractionDataBuilder {
  private data?: RoktAnalyticsData;

  constructor(data?: RoktAnalyticsData) {
    this.data = data;
  }

  build(): PublicInternalAnalyticsTrackingSerializerWithLabelString | null {
    if (!this.data) return null;
    return {
      label: enums.INTERACTION_LABEL_MAP.ROKT_ENGAGEMENT.id,
      interaction_type: enums.INTERACTION_TYPE_MAP.INITIATE_CHECKOUT.id,
      venue_id: this.data.venueId,
      custom_params: this.data.additionalParams,
    };
  }
}
